import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AddRemarkModalUI from './AddRemarkModalUI'

class AddRemarkModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      remark: (props.item && props.item.remarks) ? props.item.remarks : '',
      submitting: false,
      successMsg: null,
      errorList: []
    }
  }

  onRemarkChange = (value) => {
    this.setState({ remark: value })
  }

  onSubmitClick = () => {
    if (this.state.submitting) return

    const { remark } = this.state

    if (!remark || remark.trim() === '') {
      this.setState({
        errorList: ['Remark cannot be empty']
      })
      return
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitting: true
    })

    const loanId = this.props.loan.loanId
    const fileCode = this.props.item.fileCode

    const requestBody = {
      remark: remark.trim()
    }

    RestApiUtils.post(
      this.props.context,
      `/api/disbursement-checklist/${loanId}/item/${fileCode}/remark`,
      this.onSubmitCallback,
      requestBody,
      null
    )
  }

  onSubmitCallback = (response) => {
    const errorList = []

    if (response.errorList && response.errorList.length > 0) {
      response.errorList.forEach(error => {
        errorList.push(error.message || error)
      })
    }

    this.setState({
      successMsg: response.success || response.message || 'Remark saved successfully',
      errorList: errorList,
      submitting: false
    })

    if (errorList.length === 0 && (response.success || response.checklist)) {
      setTimeout(() => {
        if (this.props.onSuccess) {
          this.props.onSuccess()
        } else {
          this.props.onCancelClick()
        }
      }, 1500)
    }
  }

  render() {
    return (
      <AddRemarkModalUI
        item={this.props.item}
        remark={this.state.remark}
        onRemarkChange={this.onRemarkChange}
        onSubmitClick={this.onSubmitClick}
        onCancelClick={this.props.onCancelClick}
        submitting={this.state.submitting}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
      />
    )
  }
}

export default AddRemarkModalSF	